import { ReactNode } from 'react';

import { useTable } from './Table';
import { cn } from 'styles';
import { tableStyleConfig } from './styles';

interface TableRowProps {
  children: ReactNode;
  className?: string;
}

export function TableRow({ children, className }: TableRowProps) {
  const { rowClassName, rowDivisor } = useTable();

  return (
    <tr className={cn(tableStyleConfig.rowDivisor[rowDivisor], rowClassName, className)}>
      {children}
    </tr>
  );
}
